import styled from "styled-components";

export const MainContainer = styled.div`
  flex-direction: column;
  background: #f6f6f9;
  min-height: 100dvh;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  align-items: center;
  position: relative;
  padding: 4rem 4rem 8rem 4rem;
  min-height: calc(100dvh - 260px);

  width: 100%;
  margin-top: 140px;
  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 1200px) {
    margin-top: 126px;
  }
  @media (max-width: 870px) {
    margin-top: 79px;
    padding: 2rem 2rem 8rem 2rem;
  }
  @media (max-width: 380px) {
    margin-top: 65px;
  }
`;

export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-top: 40px;
`;
export const ItemContainer = styled.div`
  display: flex;

  flex-direction: row;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 40px;
`;
export const Title = styled.span`
  font-size: 32px;
  font-family: "Avenir-Black";

  letter-spacing: 0.5%;
  text-align: center;
  color: #484888;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  margin-top: ${(props) => (props.$upgradePackage ? "160px" : "100px")};
`;
